import { render, staticRenderFns } from "./TopCarousel.vue?vue&type=template&id=e1a3c40a&scoped=true&"
import script from "./TopCarousel.vue?vue&type=script&lang=js&"
export * from "./TopCarousel.vue?vue&type=script&lang=js&"
import style0 from "./TopCarousel.vue?vue&type=style&index=0&id=e1a3c40a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a3c40a",
  null
  
)

export default component.exports